import React from 'react';
import styles from '../css/vdr.module.css';

export const STATUS = {
    ready: 'ready',
    processing: 'processing',
    needs_attention: 'needs_attention',
};

export function normalizeStatus(raw) {
    if (!raw) return STATUS.ready;
    const s = String(raw).toLowerCase().replace(/\s+/g, '_');
    if (s.includes('fail') || s.includes('attention') || s === 'error') return STATUS.needs_attention;
    if (s.includes('process') || s.includes('index') || s === 'uploading') return STATUS.processing;
    return STATUS.ready;
}

export function indexingStatusLabel(status) {
    const normalized = normalizeStatus(status);
    if (normalized === STATUS.needs_attention) return 'Not indexed';
    if (normalized === STATUS.processing) return 'Indexing';
    return 'Indexed';
}

export function StatusDot({ status, label }) {
    const normalized = normalizeStatus(status);
    const className =
        normalized === STATUS.needs_attention ? styles.dotAttention : normalized === STATUS.processing ? styles.dotProcessing : styles.dotReady;
    const text = label || indexingStatusLabel(status);
    return (
        <span className={`${styles.statusDot} ${className}`}>
            {text}
        </span>
    );
}

/** variant="inline" — Figma folder selection: plain text filters + tight ring on active */
export function StatusFilters({ value, onChange, counts, variant }) {
    const pills = [
        { key: 'all', label: 'All' },
        { key: 'ready', label: 'Ready' },
        { key: 'processing', label: 'Processing' },
        { key: 'needs_attention', label: 'Needs attention' },
    ];
    const inline = variant === 'inline';
    return (
        <div className={`${styles.filterPills} ${inline ? styles.filterPillsInline : ''}`}>
            {pills.map(p => {
                const active = value === p.key;
                return (
                    <button
                        key={p.key}
                        type="button"
                        className={[
                            styles.filterPill,
                            inline ? styles.filterPillInline : '',
                            active ? (inline ? styles.filterPillInlineActive : styles.filterPillActive) : '',
                        ]
                            .filter(Boolean)
                            .join(' ')}
                        onClick={() => onChange(p.key)}
                    >
                        {p.label}
                        {counts?.[p.key] != null ? ` (${counts[p.key]})` : ''}
                    </button>
                );
            })}
        </div>
    );
}

/** variant="inline" — Figma folder selection: icon + placeholder, no box/border */
export function SearchField({ value, onChange, placeholder = 'Search…', variant }) {
    const inline = variant === 'inline';
    return (
        <div className={`${styles.searchInput} ${inline ? styles.searchInputInline : ''}`}>
            <span className={styles.searchIcon} aria-hidden>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="6.2" cy="6.2" r="4.4" stroke="currentColor" strokeWidth="1.3" />
                    <path d="M9.4 9.4L12.2 12.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
                </svg>
            </span>
            <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} />
        </div>
    );
}
